import { Injectable } from '@angular/core';
import { SuccessSnackbarComponent } from './support/success-snackbar/success-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';


@Injectable()
export class messageService {
  message: any = [];

  deviceInfo: any = {
    browser: String,
    browserVersion: Number,
    os: String,
    osVersion: String,
    deviceType: String || 'Desktop',
    deviceName: String + ' on ' + String
  }

  private loggedOrgId: number | string;
  private loggedUserId: number | string;

  public setOrgId(orgId: string | number) {
    this.loggedOrgId = orgId;
  }

  public setUserId(userId: string | number) {
    this.loggedUserId = userId;
  }

  public getOrgId() {
    return this.loggedOrgId;
  }

  public getUserId() {
    return this.loggedUserId;
  }

  orgData: any;
  lastmsg: any = {};
  groupId: any;
  isAuditTrailUser: boolean = false;
  isTopicAdministrator: boolean = false;
  isPrintAdministrator: boolean = false;
  isTrainingGroupAdministrator: boolean = false;
  isTrainingAdministrator:boolean = false;
  productIdFromProductMaster: any;
  isShowApplicableForAllCheckBox = false;
  isTagHomeFromHome = false;
  docsList: any = [];
  masterDetails: any = {};
  breadcrumbData: any = {
    firstLevel: '',
    secondLevel: '',
    thirdLevel: '',
    fourthLevel: '',
    fifthLevelFromDependency: '',
    sixthLevelFromDependency: ''
  }
  gridList: any = [];
  gridListForAuditTrails: any = [];
  showLeftMenu: any = "Main";
  activityLeftmenuList: any = [];
  activityDynamicButtonList: any;
  activity: any;
  activityId: any = null;
  businessProcessObj = {};
  version: any = null;
  isMyTaskFromDashboard = false;
  communicatingFrom: any = String;
  serviceFromDocumentsForCommunication: any;
  serviceFromTrainingsForCommunication: any;
  templateIdFromQmsReportTemplate: any;
  groupNameFromQmsReportTemplate: any;
  moduleFromQmsReportTemplate: any;
  subModule: any;
  templateIdFromQmsQuestionnaireTemplate: any;
  ecMasterDetails: any = {};
  showIncidentSwitch: any = false;
  showComplaintSwitch: any = false;
  changeRequestCode: any;
  tenantId: any = "";
  clientId: any = null;
  hostName: any = "";
  sitePath: any = "";
  //ActivitySections
  showCRDetailsSection: boolean;
  showAddtionalDetailSection: boolean;
  showReviewApproveSection: boolean;
  showEffectiveSection: boolean;
  showActionSection: boolean;
  showPreActionsTab: boolean = false;
  showRiskTab: boolean;
  showDocumentSection: boolean;
  showNotificationSection: boolean;
  showDependancySection: boolean;
  showExtensionSection: boolean;
  showInvestigationSection: boolean;
  showRetakeAndMarkasCompleted = false;
  //periodic review
  reviewPeriodIdVal: any;
  userIdVal: any;
  showIncidentLoggingSections: boolean;
  showCompleteIncidentSections: boolean;
  showInSaveButton: boolean;
  showQiLoggingSection: boolean;
  showCompleteQiSection: boolean;
  showComplaintIdentificationSection: boolean;
  showProductsTab: boolean;
  showFinalEvaluationTab: boolean;
  showReimbursementTab: boolean;
  showResponseTab: boolean;
  showPreliminaryTab: boolean = false;
  showDataEvaluationTab: boolean = false;
  showClosureTab: boolean = false;


  showDocumentActionButtons: boolean;
  showActionsActionButtons: boolean;
  showPreActionsActionButtons: boolean = false;
  showDependencyActionButton: boolean;
  showReviewApproveActionButtons: boolean;
  showEffectiveActionButtons: boolean;
  showProductsActionButtons: boolean;
  showParallelWorkflowActionButtons: boolean = false;
  dmsReportButtonVal: any;
  tmsReportButtonVal: any;
  taskLevelData: any;
  reviewPeriodName: any;
  reviewPeriodId: any;
  reviewPeriodDescription: any;
  chosenPeriod: any;
  isIssuanceFrom: any = "Document;";
  formsAndLogsStatus: any = ";";

  isInitiationFrozen: boolean = false;
  isPreliminaryFrozen: boolean = false;
  isLabTabsFrozen: boolean = false;
  isPhaseIIL1Frozen: boolean = false;
  isPhaseIIL2Frozen: boolean = false;
  isPhaseIIIL1Frozen: boolean = false;
  isPhaseIIIL2Frozen: boolean = false;
  isLevel1EvaluationFrozen: boolean = false;
  isLevel2EvaluationFrozen: boolean = false;
  isClosureFrozen: boolean = false;

  constructor(private readonly snackBar: MatSnackBar) { }

  showIndividualContentIfFromTrainingsContentPage: boolean = false
  individualContentsContentId: any;
  sendBackToContent: boolean = false;

  switchUserdropDownList: any = [];
  switchedUser: any;
  submodule: any;
  subModuleId: any;
  switchuserRole: any;
  switchUserCurrentValue: any;
  switchusePagename: any;
  switchComparisonUser: number | string | null;

  showSwitchUser: boolean;
  isDocumentDownloader: boolean;
  dataGridAdmin: boolean;

  myTaskData: any = [];

  isAuditee: boolean;

  tableOrView_Name: string = "";
  columnList_DB: string = "";
  columnList_UI: string = "";
  columnList_INVISIBLE: string = "";
  manualEntryDataFields: string = "";
  columnList_Report: string = "";
  whereClause_AU: string = "";
  whereClause_Report: string = "";
  reportName_AU: string = "";
  report_And_Popup_Name: string = "";
  sectionId: any;
  templateId: any;

  organizationDetails: any;
  navigatedReportTemplateName: string = '';

  supportTicketsListData: any = [];

  scheduledTrainingsApprover: any = null;

  currentSwitchuser: any = null;

  permittedFileExtensions: string = '';

  logoutInMinutes: any;

  isfindingsFrom: any;
  businessProcess: any = {};
  showbreadcrumb: boolean = true;

  qmsSettings: any = {};
  tabPagesOrderlist: any = []
  primarySelectorAtUIPageList: any = [];

  questionnaireModule: string = '';
  clearcache: boolean;

  isFromOosCategory: boolean = false;
  isFromImpactAssessmentFields: boolean = false;

  isFromCheckListTemplateFields: boolean = false;

  addMapCapaComponentDetails: { capaID: '', shortDescription: '' };
  addMapCapaFindings: { capaNo: any, capaId: '', status: '' };
  isFromFindings: boolean = false;
  isEcPerformer: boolean = false;

  public verifySingleFileSize(input: HTMLInputElement): boolean {

    if (!input.files || input.files.length === 0) {
      return false;
    }

    const maxSizeMb = this.organizationDetails.allowedFileSizeInMb;
    const maxSizeBytes = maxSizeMb * 1024 * 1024;

    const file = input.files[0];
    const fileSizeBytes = file.size;

    if (fileSizeBytes > maxSizeBytes) {

      const fileSizeMb = fileSizeBytes / (1024 * 1024);

      setTimeout(() => { this.showSnackBar(`File Limit Exceeded | Allowed: ${maxSizeMb} MB | Selected: ${fileSizeMb.toFixed(2)} MB`, 'N'); });

      input.value = '';
      console.log("File rejected:", file);

      return false;
    }

    console.log("File accepted:", file);
    return true;
  }

  public verifyMultipleFileSize(input: HTMLInputElement, previousSelectedFiles: File[]): boolean {

    const maxSizeMb = this.organizationDetails.allowedFileSizeInMb;
    const maxSizeBytes = maxSizeMb * 1024 * 1024;

    const selectedFilesArray = Array.from(input.files ?? []);

    /* Calculate already selected files size */
    let existingSizeBytes = 0;
    for (const file of previousSelectedFiles) {
      existingSizeBytes += file.size;
    }

    /* Calculate newly selected files size */
    let newFilesSizeBytes = 0;
    for (const file of selectedFilesArray) {
      newFilesSizeBytes += file.size;
    }

    const totalSizeBytes = existingSizeBytes + newFilesSizeBytes;

    if (totalSizeBytes > maxSizeBytes) {

      const totalSizeMb = totalSizeBytes / (1024 * 1024);
      const existingSizeMb = existingSizeBytes / (1024 * 1024);
      const newFilesSizeMb = newFilesSizeBytes / (1024 * 1024);

      setTimeout(() => { this.showSnackBar(`File Limit Exceeded | Allowed: ${maxSizeMb} MB | Existing: ${existingSizeMb.toFixed(2)} MB | Selected: ${newFilesSizeMb.toFixed(2)} MB | Total: ${totalSizeMb.toFixed(2)} MB`, 'N') });

      input.value = '';
      return false;
    }

    return true;
  }

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    let messageType: string;

    if (type === 'S') {
      messageType = 'Success';
    } else if (type === 'E') {
      messageType = 'Error';
    } else {
      messageType = 'Notice';
    }

    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: messageType,
        buttonLabel: 'Ok',
        pageName: this.breadcrumbData.thirdLevel ? this.breadcrumbData.thirdLevel : this.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }


}
